import {RefObject} from 'react';
import {createPortal} from 'react-dom';
import {useFormContext} from 'react-hook-form';
import {EsimPackage} from '@chekin/core';
import {TotalToPayForm} from './TotalToPayForm';
import {MobileTotalToPayForm} from './MobileTotalToPayForm';
import {DEVICE, useScreenResize} from '@chekin/guestapp-ui-kit';

type Props = {
  currencySign?: string;
  isLoading: boolean;
  className?: string;
  esimPackages: EsimPackage[];
  formId: string;
  bottomPanelRef?: RefObject<HTMLDivElement>;
};
export const TotalToPay = ({
  className,
  esimPackages,
  formId,
  isLoading,
  currencySign,
  bottomPanelRef,
}: Props) => {
  const {isMatch} = useScreenResize(DEVICE.mobileXL);
  const isMobileMode = isMatch && bottomPanelRef?.current;
  const {setValue, unregister} = useFormContext();

  const handleChange =
    (id: string, onChange: (value: number) => void) => (value: number) => {
      if (value <= 0) {
        setValue(`${id}.checked`, false);
        unregister(`${id}.count`);
      } else {
        onChange(value);
      }
    };

  return isMobileMode ? (
    createPortal(
      <MobileTotalToPayForm
        isLoading={isLoading}
        esimPackages={esimPackages}
        formId={formId}
        onChange={handleChange}
        currencySign={currencySign}
      />,
      bottomPanelRef.current,
    )
  ) : (
    <TotalToPayForm
      className={className}
      isLoading={isLoading}
      esimPackages={esimPackages}
      formId={formId}
      onChange={handleChange}
      currencySign={currencySign}
    />
  );
};
